"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation createOrganization($orgName: String) {
  createOrganization(orgName:$orgName) {
    _id
    __typename
  }
}
`;
exports.default = mutation;
//# sourceMappingURL=createOrganisation.mutation.js.map